import types from 'actions/types'
import { createPivotTableReducer } from 'reducers/pivotTable'
import { combineReducers } from 'redux'

const folders = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_DOCUMENTS_ADD_FOLDER:
      return [
        ...state,
        action.folder,
      ]
    case types.QUOTING_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY: return [action.folder]
    case types.QUOTING_DOCUMENTS_REMOVE_FOLDERS_AFTER_INDEX: return state.slice(0, action.index)
    case types.QUOTING_DOCUMENTS_REMOVE_FOLDER: return state
    default: return state
  }
}

const rootFolder = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY: return action.folder
    case types.QUOTING_DOCUMENTS_LOAD_PARENT_FOLDER_SUCCESS: return action.data
    default: return state
  }
}

const parentFolder = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_DOCUMENTS_LOAD_PARENT_FOLDER_SUCCESS: return action.data
    default: return state
  }
}

const currentFolder = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY: return action.folder
    case types.QUOTING_DOCUMENTS_LOAD_PARENT_FOLDER_SUCCESS: return action.data
    case types.QUOTING_DOCUMENTS_ADD_FOLDER: return action.folder
    default: return state
  }
}

const subFolder = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_DOCUMENTS_SET_SELECTED_SUB_FOLDER:
      return action.path
    default:
      return state
  }
}

export const quotingContextDocumentsPivotTableKey = 'quotingContext.selected.documents.pivotTable'

export default combineReducers({
  folders,
  rootFolder,
  parentFolder,
  currentFolder,
  subFolder,
  pivotTable: createPivotTableReducer({key: quotingContextDocumentsPivotTableKey, defaultSortColumn: 'folderName'}),
})
